const clickEvent = (call) => {
  ['mousedown', 'touchstart'].forEach((eventType) => {
    let timer = null
    window.addEventListener(eventType, (event) => {
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        const target = event.target
        const { top, left } = target.getBoundingClientRect()
        call && call({
          top,
          left,
          eventType,
          pageHeight: document.documentElement.scrollHeight || document.body.scrollHeight,
          scrollTop: document.documentElement.scrollTop || document.body.scrollTop,
          type: 'behavior',
          subType: 'click',
          target: target.tagName,
          // paths: (event as any).path?.map((item : any) => item.tagName).filter(Boolean),
          startTime: event.timeStamp,
          outerHTML: target.outerHTML,
          innerHTML: target.innerHTML,
          width: target.offsetWidth,
          height: target.offsetHeight,
          viewport: {
            width: window.innerWidth,
            height: window.innerHeight
          }
        })
      }, 500)
    })
  })
}

export { clickEvent }
